export const practiceAttributes = [
    {
        label: 'Account Information',
        type: 'section',
    },
    {
        id: 'name',
        label: 'Name',
        required: true,
    },
    {
        id: 'email',
        label: 'Email',
        type: 'email',
        errorMessage: 'Please enter a valid email address',
        required: true,
    },
    {
        id: 'territory',
        label: 'Territory',
        type: 'select',
        items: [
            'ACT-1',
            'NSW-1',
            'NSW-2',
            'NT-1',
            'QLD-1',
            'QLD-2',
            'SA-1',
            'TAS-1',
            'VIC-1',
            'WA-1',
            'WA-2',
            'NewCal-1',
            'NZ-1',
            'Tahiti-1',
        ],
        required: true,
    },
    {
        label: 'Legal Name & Address',
        type: 'section',
    },
    {
        id: 'tradingName',
        label: 'Trading Name',
        required: true,
    },
    {
        id: 'abn',
        label: 'ABN',
        type: 'number',
    },
    {
        id: 'address',
        label: 'Street Address',
        required: true,
    },
    {
        id: 'suburb',
        label: 'Suburb',
        required: true,
    },
    {
        id: 'postcode',
        label: 'Postcode',
        type: 'number',
        required: true,
    },
    {
        id: 'state',
        label: 'State/Country',
        type: 'select',
        items: ['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA', 'NewCal', 'NZ', 'Tahiti'],
        required: true,
    },
    {
        label: 'Contact Details',
        type: 'section',
    },
    {
        id: 'practiceManager',
        label: 'Practice Manager Name',
    },
    {
        id: 'practiceManagerEmail',
        label: 'Practice Manager Email',
        type: 'email',
        errorMessage: 'Please enter a valid email address',
    },
    {
        id: 'prescriber1',
        label: 'Prescriber Name 1',
    },
    {
        id: 'prescriber2',
        label: 'Prescriber Name 2',
    },
    {
        id: 'prescriber3',
        label: 'Prescriber Name 3',
    },
    {
        id: 'prescriber4',
        label: 'Prescriber Name 4',
    },
    {
        id: 'phoneNumber',
        label: 'Phone Number',
        type: 'tel',
    },
    {
        label: 'Treatment Notes',
        type: 'section',
    },
    {
        id: 'allowFullArchTreatment',
        label: 'Allow Full Arch Treatment',
        type: 'select',
        items: ['Yes', 'No'],
        required: true,
    },
    {
        id: 'scanOrImpression',
        label: 'Scan Or Impression',
        type: 'select',
        items: ['Scan', 'Impression'],
    },
    {
        id: 'scannerBrand',
        label: 'Scanner Brand',
    },
    {
        id: 'clearAlignerBrand',
        label: 'Clear Aligner Brand',
    },
    {
        id: 'pricingNotes',
        label: 'Pricing / Notes',
        type: 'textArea',
    },
];
